/* ============================================
   SHOPIFY BLANK THEME - theme.js
   ============================================ */

// Cart
class CartManager {
  static async addItem(formData) {
    const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    });
    return response.json();
  }
  static async getCart() {
    const response = await fetch('/cart.js');
    return response.json();
  }
  static async updateItem(id, quantity) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, quantity })
    });
    return response.json();
  }
}

// Update cart count in header
async function updateCartCount() {
  const cart = await CartManager.getCart();
  document.querySelectorAll('.cart-count').forEach(el => {
    el.textContent = cart.item_count;
    el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
  });
}

// Add to Cart form handler
document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const originalText = btn?.textContent;
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    const formData = Object.fromEntries(new FormData(form));
    await CartManager.addItem(formData);
    await updateCartCount();
    if (btn) { btn.disabled = false; btn.textContent = originalText; }
  });
});

// Mobile nav toggle
const navToggle = document.querySelector('.nav-toggle');
const navMenu = document.querySelector('.site-nav--mobile');
if (navToggle && navMenu) {
  navToggle.addEventListener('click', () => {
    const open = navMenu.getAttribute('aria-expanded') === 'true';
    navMenu.setAttribute('aria-expanded', String(!open));
    navMenu.style.display = open ? 'none' : 'block';
  });
}

// Variant selector
document.querySelectorAll('.variant-selector').forEach(selector => {
  selector.addEventListener('change', () => {
    const form = selector.closest('form');
    const selected = selector.options[selector.selectedIndex];
    const available = selected?.dataset.available !== 'false';
    const btn = form?.querySelector('[type="submit"]');
    if (btn) {
      btn.disabled = !available;
      btn.textContent = available ? 'Add to Cart' : 'Sold Out';
    }
    const priceEl = form?.closest('.product')?.querySelector('.product__price');
    if (priceEl && selected?.dataset.price) {
      priceEl.textContent = formatMoney(parseInt(selected.dataset.price));
    }
  });
});

// Quantity input
document.querySelectorAll('.quantity__button').forEach(btn => {
  btn.addEventListener('click', () => {
    const input = btn.closest('.quantity')?.querySelector('.quantity__input');
    if (!input) return;
    const current = parseInt(input.value) || 1;
    input.value = btn.dataset.action === 'increase' ? current + 1 : Math.max(1, current - 1);
  });
});

function formatMoney(cents) {
  return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: Shopify?.currency?.active || 'USD' });
}

document.addEventListener('DOMContentLoaded', updateCartCount);

/* ============================================
   GLOBAL WISHLIST LOGIC
   ============================================ */
class WishlistManager {
  static KEY = 'theme_wishlist';

  static getItems() {
    try {
      return JSON.parse(localStorage.getItem(this.KEY)) || [];
    } catch(e) {
      return [];
    }
  }

  static saveItems(items) {
    localStorage.setItem(this.KEY, JSON.stringify(items));
    this.updateAllButtons();
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: items }));
  }

  static toggle(productData) {
    let items = this.getItems();
    const existsIndex = items.findIndex(item => String(item.handle) === String(productData.handle));
    
    if (existsIndex > -1) {
      items.splice(existsIndex, 1);
      alert('Removed from Wishlist');
    } else {
      items.push(productData);
      alert('Saved to Wishlist!');
    }
    
    this.saveItems(items);
  }

  static updateAllButtons() {
    const items = this.getItems();
    
    // Update count badges
    document.querySelectorAll('.wishlist-count').forEach(el => {
      el.textContent = items.length;
      el.style.display = items.length > 0 ? 'inline-flex' : 'none';
    });

    // Update active states on buttons
    document.querySelectorAll('.js-wishlist-toggle').forEach(btn => {
      const handle = btn.dataset.handle;
      if (!handle) return;
      
      const exists = items.some(item => String(item.handle) === String(handle));
      if (exists) {
        btn.classList.add('wishlist-active');
      } else {
        btn.classList.remove('wishlist-active');
      }
    });
  }
}
window.WishlistManager = WishlistManager;

// Global click listener for wishlist toggles
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.js-wishlist-toggle');
  if (!btn) return;
  e.preventDefault();
  
  const productData = {
    handle: btn.dataset.handle,
    id: btn.dataset.id || btn.dataset.handle, // fallback
    title: btn.dataset.title,
    price: btn.dataset.price,
    compare_at_price: btn.dataset.comparePrice, // <--- SAVES THE COMPARE PRICE TO LOCAL STORAGE HERE!
    image: btn.dataset.image,
    url: btn.dataset.url
  };
  
  if(!productData.handle) return;
  WishlistManager.toggle(productData);
});

// Sync UI on load
document.addEventListener('DOMContentLoaded', () => {
  WishlistManager.updateAllButtons();
});